"use client";
import { DATA_LAYER_PAGE_NAMES } from "@/constants/dataLayer";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Register from "./Register";
import VirtualPvEvent from "./VirtualPvEvent";

const LoginRegister = () => {
  const { hideLoginModal, activeTab, setActiveTab } = useAuth();
  const t = useTranslationDetector();

  // Title'ı active tab'a göre belirle
  const getTitle = () => {
    switch (activeTab) {
      case "login":
        return t("loginmodal.title");
      case "register":
        return t("registermodal.title");
      case "forgotPassword":
        return "";
      default:
        return t("loginmodal.title");
    }
  };

  const getDescription = () => {
    switch (activeTab) {
      case "login":
        return t("loginmodal.description");
      case "register":
        return t("registermodal.description");
      case "forgotPassword":
        return "";
    }
  };

  // Tab geçişleri için handler'lar
  const handleShowRegister = () => setActiveTab("register");
  const handleShowLogin = () => setActiveTab("login");
  const handleShowForgotPassword = () => setActiveTab("forgotPassword");
  const handleBackToLogin = () => setActiveTab("login");
  return (
    <div className="flex flex-col gap-5">
      <VirtualPvEvent
        pageType={DATA_LAYER_PAGE_NAMES.LOGIN_REGISTER_PAGE}
        pageUrl="pop-up"
      />
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          {activeTab === "forgotPassword" && (
            <button
              onClick={handleBackToLogin}
              className="cursor-pointer transition-colors hover:text-gray-400"
            >
              <FontAwesomeIcon
                icon={byPrefixAndName.far["angle-left"]}
                className="text-xl"
              />
            </button>
          )}

          <span className="text-foreground text-lg font-semibold">
            {/* {getTitle()} */}
          </span>
          <button
            className="cursor-pointer transition-colors hover:text-gray-400"
            onClick={hideLoginModal}
          >
            <FontAwesomeIcon
              icon={byPrefixAndName.far["xmark"]}
              className="text-xl"
            />
          </button>
        </div>

        <div className="flex flex-col gap-2 text-center">
          <h5 className="text-2xl font-semibold">{getTitle()}</h5>
          <p className="text-primary-muted-subtext">{getDescription()}</p>
        </div>
      </div>
      {activeTab === "login" && (
        <Login
          onForgotPassword={handleShowForgotPassword}
          onRegister={handleShowRegister}
        />
      )}

      {activeTab === "register" && <Register onBackToLogin={handleShowLogin} />}

      {activeTab === "forgotPassword" && (
        <ForgotPassword onBackToLogin={handleShowLogin} />
      )}
    </div>
  );
};

export default LoginRegister;
